export default __webpack_public_path__ + "static/media/csharp.834de1bc.svg";